export default function MintegralLogo() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6V15H4V10.2361L7.10557 15H8.89443L12 10.2361V15H14V6H11.882L8 12.7639L4.11803 6H2Z"
        fill="var(--text-primary-color)"
        className="path-fill"
      />
      <rect y="1" width="8" height="4" fill="#38BEA5" className="path-fill" />
      <rect
        x="8"
        y="1"
        width="5"
        height="4"
        fill="#FDCF09"
        className="path-fill"
      />
      <rect
        x="13"
        y="1"
        width="3"
        height="4"
        fill="#272830"
        className="path-fill"
      />
    </svg>
  );
}
